import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  TransportIcon,

  SupportMajorLoadTypes,
  VehicleMaster,
  RouteMaster,
  SeamlessConsignmentNote,
  EwaybillTransmit,
  FuelContract,
} from '../../assets';

const TransportPage = () => {
  const productData = {
    productName: 'Transport',
    tagline: 'Complete Visibility Over Transport Operations',
    metaDescription: 'Road freight management software: e-waybill generation & transmission, consignment notes, fleet management, and route optimisation. Built for Indian road logistics.',
    description: 'Take control of your road logistics. Distinct capabilities for managing Customer Orders, Full/Break Bulk loads, Fleet (Vehicle/Driver) management, and Route optimization.',
    icon: TransportIcon,
    features: [
      {
        title: 'Support for Major Load Types',
        description: 'Comprehensive support for various load types including FCL, LTL, and FTL (Break Bulk, Bulk, Liquid).',
        image: SupportMajorLoadTypes,
      },
      {
        title: 'Vehicle & Driver Master',
        description: 'Manage your entire fleet and driver database efficiently in one place.',
        image: VehicleMaster,
      },
      {
        title: 'Route Master',
        description: 'Optimize delivery routes and manage standard routes for recurring shipments.',
        image: RouteMaster,
      },
      {
        title: 'Seamless Consignment Note Generation',
        description: 'Generate consignment notes instantly with automated data population.',
        image: SeamlessConsignmentNote,
      },
      {
        title: 'E-Waybill Generation & Transmission',
        description: 'Generate and transmit E-waybills directly to the portal with minimal manual intervention.',
        image: EwaybillTransmit,
      },
      {
        title: 'Fuel Contract Management',
        description: 'Manage fuel contracts and track consumption efficiently.',
        image: FuelContract,
      },
    ],

  };

  return <ProductPageTemplate {...productData} />;
};

export default TransportPage;
